/* Centerfaced 2.0 — cf-motion.js (~1.3KB, deferred)
   Gentle scroll-in for the custom sections Shrine's own observer doesn't
   cover: the Centerfaced collection grid (.cfcg-h2, .cfcg-card) and the
   featured-product bundle block. Opt-in hook for future sections:
   add data-cf-motion to any element.
   Progressive enhancement: the hidden state in cf-redesign.css only applies
   under html.cf-motion-ready (added below), so with no JS — or with
   prefers-reduced-motion — nothing is ever hidden. Animates transform/opacity
   only (no CLS), runs once per element, does not touch Shrine's
   .animate-section observer. */
(function () {
  'use strict';

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduce || !('IntersectionObserver' in window)) return;

  var SELECTOR = '.cfcg-h2, .cfcg-card, .section-featured-product .featured-product, [data-cf-motion]';
  var STAGGER = 70;    /* ms between items revealed in the same batch */
  var MAX_DELAY = 350; /* cap so long card rows never feel slow */

  var io = new IntersectionObserver(
    function (entries) {
      var i = 0;
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        io.unobserve(entry.target);
        var el = entry.target;
        el.style.transitionDelay = Math.min(i++ * STAGGER, MAX_DELAY) + 'ms';
        el.addEventListener('transitionend', function h() {
          el.style.transitionDelay = '';
          el.removeEventListener('transitionend', h);
        });
        el.classList.add('cf-motion-in');
      });
    },
    /* fire slightly early: 60px before the element reaches the viewport */
    { threshold: 0.15, rootMargin: '0px 0px 60px 0px' }
  );

  var els = document.querySelectorAll(SELECTOR);
  if (!els.length) return;

  /* Arm the hidden state only now that we know we can reveal things. */
  document.documentElement.classList.add('cf-motion-ready');
  for (var i = 0; i < els.length; i++) io.observe(els[i]);

  /* Theme editor: re-rendered sections appear instantly (mirrors Shrine). */
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (e) {
      var fresh = e.target.querySelectorAll(SELECTOR);
      for (var j = 0; j < fresh.length; j++) fresh[j].classList.add('cf-motion-in');
    });
  }
})();
